<div class="container">

    <mat-toolbar class="mat-accent m-0 dialog-header">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <button mat-icon-button (click)="_matDialogRef.close()" class="full-screen-dialog-actions" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
            <span class="title dialog-title" ngClass.xs="titlefontxs">{{'ressources.Les catégories' | transloco}}</span>

            <div class="full-screen-dialog-actions">
                <button mat-button class="save-button mat-accent" aria-label="SAVE" *ngIf="add" [disabled]="VehiculeForm.invalid" (click)="_matDialogRef.close(VehiculeForm.getRawValue())" data-cy="save-button">
                {{'ressources.ajouter' | transloco}}
            </button>
                <button mat-button class="save-button mat-accent" aria-label="SAVE" #edit *ngIf="!add" [disabled]="VehiculeForm.invalid" (click)="_matDialogRef.close(VehiculeForm.getRawValue())">
                {{'ressources.Sauvegarder' | transloco}}
            </button>
            </div>


        </mat-toolbar-row>
    </mat-toolbar>

    <div class="dialog-content-wrapper content">
        <form autocomplete="off" name="VehiculeForm" [formGroup]="VehiculeForm" class="event-form w-100-p" fxLayout="column" fxFlex>
            <mat-form-field class="mr-sm-24" floatLabel="always" appearance="outline" style="width: 100%; margin-inline-end: 0; margin-inline-start: auto">
                <mat-label>{{'ressources.Categorié de voiture' | transloco}}</mat-label>
                <mat-select formControlName="type" multiple required data-cy=vehicule-type>
                    <mat-option *ngFor="let type of types" [value]=type.type>
                        {{ ('ressources.vehicle_categories.' + type.type) | transloco }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="w-100-p" floatLabel="always" appearance="outline">
                <input autocomplete="off" (keyup.enter)="_matDialogRef.close(VehiculeForm.getRawValue())" matInput formControlName="nom" placeholder="{{'ressources.nom' | transloco}}" data-cy="vehicule-name" required />
            </mat-form-field>
        
        </form>


    </div>
    <div mat-dialog-actions class="basic-dialog-actions" fxLayout="row" fxLayoutAlign="end center">
        <button mat-button (click)="_matDialogRef.close()">{{'ressources.Annuler' | transloco}}</button>
       <button mat-flat-button color="primary" aria-label="SAVE" *ngIf="add" [disabled]="VehiculeForm.invalid" (click)="_matDialogRef.close(VehiculeForm.getRawValue())" data-cy="save-button">
                {{'ressources.ajouter' | transloco}}
            </button>
       <button mat-flat-button color="primary" aria-label="SAVE" #edit *ngIf="!add" [disabled]="VehiculeForm.invalid" (click)="_matDialogRef.close(VehiculeForm.getRawValue())">
                {{'ressources.Sauvegarder' | transloco }} 
            </button>
    </div>
</div>
